import React from 'react';
import { connect } from 'react-redux';
import { Button, Col, Icon, Input, message, Row, Typography } from 'antd';

import { updateGoogleTaxonomy, updateSubCategoryImage } from './actions';

import { _getCategorySubStats, _postSaveSubCategoryImage, _putUpdateSubCategoryGoogleTaxonomy } from '../../services';

import AddSubCategoryButton from './add-sub-category-button';
import CategorySpecs from './category-specs/index';
const Text = Typography.Text

class CategoryRow extends React.Component{
	props:{
		mainCategoryAmount: number,
		category: {
			title: string,
			titleUrl: string,
			_id: string,
			children :[{
				title: string,
				titleUrl: string
			}]
		}
	}

	render(){

		const { RenderControls } = this; 

		const { category, index, mainCategoryAmount } = this.props;

		return (
			<Row key={index} style={{borderTop: "1px solid grey"}}>
			
				<Row type="flex" align="middle" className="main-category">

					<Col span={6}>
						<div style={{ padding: "4px 11px" }}>
							<Text strong>
								{category.title}
							</Text>
						</div>
						
					</Col>

					<Col span={6}>

						<RenderControls 
							onClickDelete={ (e) => this.props.deleteMainCategoryTitle( index ) }
							edited={category.edited}
							main={true}
							mainCategory={category}
							mainIndex={index}
							categoryAmount={ mainCategoryAmount }
							/>

					</Col>
				</Row>

				{this.RenderSubCategories(category, index)}
				
				{ this.state.editSpecTable? <CategorySpecs subKebabCase={ this.state.editSubKebabCase } closeSpecTableEditor={ () => this.setSpecTableEditorVisibility(false) } /> : null }

				


			</Row>
		)
	}

	// static getDerivedStateFromProps(nextProps, prevState){

	// 	if( nextProps.expanded !== prevState.parentExpanded ){

	// 		let open = {};

	// 		if( nextProps.expanded !== prevState.open ){
	// 			open = {
	// 				open: nextProps.expanded
	// 			};
	// 		}

	// 		return { ...open, parentExpanded: nextProps.expanded };
	// 	}



	// 	else return null;

	// }
 
	// componentWillReceiveProps( nextProp ){
		
		// if( nextProp.expanded !== this.props.expanded ){

		// 	if( nextProp.expanded !== this.state.open ){
		// 		this.expandMainIndex(0);
		// 	}

		// }


	// }

	RenderSubCategories = (mainCategory, mainIndex) => {
		
				const { RenderControls } = this;
				
				if(this.state.open){
					return (
						<div>
							{mainCategory.children.map(
								(subCategory, subIndex) => {
									
									const taxonomySearchParam = this.state[`${mainIndex}.${subIndex}.searchParam`];
									const taxonomyRegex = new RegExp( `(${taxonomySearchParam})`, "gi" );

									return (
										<div style={{ position:"relative" }} className="sub-category-container">

											<Row type="flex" key={subIndex} className="sub-category">
												<Col offset={1} span={12}>
													<div style={{padding: "4px 11px"}}>
														<Text strong>
															{subCategory.title}
														</Text>
													</div>
													
												</Col>
				
												<Col>
													{/* {subCategory.titleUrl} */}
		
													<RenderControls 
														onClickSave={(e) => this.handleOnSaveGoogleTaxonomy(mainIndex, subIndex)}
														onClickDelete={ (e) => this.props.deleteSubCategoryTitle( mainIndex, subIndex) }
		
														subKebabCase={ subCategory.titleUrl }
		
														edited={subCategory.edited}
														mainCategory={mainCategory}
														mainIndex={mainIndex}
														categoryAmount={ this.state.subCategoryStats && this.state.subCategoryStats[subCategory.titleUrl] }
											
														/>
												</Col>
												
												<Col>
													
													<Input
														onClick={ event => event.target.select() }
														style={{ marginLeft: 16, width:120 }}
														value={ subCategory.image } 
														onChange={ (e) => this.handleOnChangeImage(e.target.value, mainIndex, subIndex) } />
														
													<Button onClick={ () => this.handleOnSaveImage({ mainCategory, subCategory }) }>Save</Button>
													
												</Col>
												
												<Col>
													<div style={{ marginLeft: 8, height:80, width:80 }}>
														<img alt="category" style={{ maxHeight: 80, maxWidth: 80 }} src={subCategory.image} />
													</div>
												</Col>
											</Row>
											<div className="sub-category" style={{ position:"absolute", bottom: 12, left: "4.1111%" }}>
												<div style={{ position:"relative", width: 700 }}>
													<Input 
														placeholder="Google Taxonomy"
														className="ghost-input"
														value={ taxonomySearchParam || subCategory.googleTaxonomy }
														onChange={ ( e ) => {

															// filter taxonomy
															const taxonomy = this.props.googleTaxonomies.filter(
																taxonomy => taxonomy.toLowerCase().includes(e.target.value.toLowerCase())	
															).slice(0, 60);

															// set state
															this.setState({
																[`${mainIndex}.${subIndex}.dirtyInput`]: true,
																[`${mainIndex}.${subIndex}.searchParam`]: e.target.value,
																[`${mainIndex}.${subIndex}.taxonomy`]: taxonomy
															})

														}}
														/>
												

													{	
														this.state[`${mainIndex}.${subIndex}.dirtyInput`] && (
														<Button style={{ right: 26, position: "absolute" }} icon="close-square" onClick={() => this.resetTaxonomy({
															subCategory,
															mainIndex,
															subIndex
														})}/>
													)}

													{	
														taxonomySearchParam &&
														this.state[`${mainIndex}.${subIndex}.taxonomy`] && 
														this.state[`${mainIndex}.${subIndex}.taxonomy`].length > 0 && (

														<div style={{ position:"absolute", top: 33, background: "white", width: 600, zIndex: 999999999, maxHeight: 300, overflowY:"scroll" }}>
															{this.state[`${mainIndex}.${subIndex}.taxonomy`].map(
																	_taxonomy => (
																		<div 
																			onClick={ () => this.updateGoogleTaxonomy({
																				mainIndex,
																				subIndex,
																				googleTaxonomy: _taxonomy
																			}) }
																			dangerouslySetInnerHTML={{ 
																				__html:_taxonomy.replace( taxonomyRegex, `<span class="highlight-text">$1</span>`) 
																			}} 
																			style={{ padding: 6, borderBottom: "1px solid #EEEEEE"}}/>
																	)
															)}
														</div>

													)}
												</div>
											</div>
										</div>
									);
								}
							)}
						</div>
					)
				}
		
				return ('');
				// {
				// 	this.state.open[mainIndex]?
				// 	<div>
				// 		{mainCategory.children.map(
				// 			(subCategory) => (
				// 				<Row>
				// 					<Col offset={2} span={6}>
				// 						{subCategory.title}
				// 					</Col>
		
				// 					<Col>
				// 					</Col>
				// 				</Row>
				// 			)
				// 		)}
				// 	</div>:
				// 	""
				// }
		
			}

	RenderControls = ({
		main = false,
		edited,
		mainCategory, 
		mainIndex, 
		onClickDelete,
		onClickSave, 
		categoryAmount,
		subKebabCase
	}) => {
		return (
			<Row gutter={8} align="middle" type="flex">
				{
					categoryAmount && (
						<Col>
							{/* <Button 
								disabled={true} 
								type="primary" >
								{categoryAmount}
							</Button> */}
							{categoryAmount}
						</Col>
					)
				}

				{
					main?
					<Col>
						{
							this.state.open?
							
							<Button type={"primary"} onClick={() => this.expandMainIndex(mainIndex)} shape="circle">
								<Icon type="caret-down"/>	
							</Button>:
							<Button onClick={() => this.expandMainIndex(mainIndex)} shape="circle" icon="caret-right" />
						}
					</Col>:
					""
				}

				{
					main?
					<Col>
						<AddSubCategoryButton
							mainCategory={mainCategory}
						/>
					</Col>:
					""
				}

				<Col>

				<Button 
					disabled={!edited} 
					type="primary" 
					shape="circle" 
					icon="save" 
					onClick={ onClickSave } />
				</Col>

				<Col>
					<Button 
						disabled={ categoryAmount > 0 } 
						type="danger" 
						shape="circle" 
						icon="delete" 
						onClick={ onClickDelete }/>
				</Col>

				{
					!main?
						<Col>
						
						{/* <Icon type="table" /> */}
							<Button 
								shape="circle" 
								icon="setting"
								onClick={ () => this.setSpecTableEditorVisibility( true, subKebabCase  ) }/>
						</Col>:
						null
				}
			{/* <Icon type="caret-down" />:
				<Icon type="caret-right"/> */}

				{/* {
					main &&
					<Col>
						<Button
							type={this.props.category.categoryFeatureId?"danger":'default'}
							shape="circle"
							icon="fire"
							onClick={()=>window.open(`/category/${this.props.category._id}`)}
							/>
					</Col>
				} */}

		</Row>
		)
	}

	RenderGhostInput = ({value, onChange}) => {
		return (
			<Input 
				onChange={onChange}
				className="ghost-input" 
				value={value.title} />
		)
	}

	state = {
		open:false,
		editSpecTable: false
	}

	expandMainIndex = (index) => {

		_getCategorySubStats( this.props.category.titleUrl )
			.then( res => {
				const subCategoryStats = res.data.reduce(
					( acc, cur ) => {
						
						acc[cur._id] = cur.count;
						return acc;

					},{}
				);

				this.setState({
					subCategoryStats
				})
			})

		this.setState({
			open: this.state.open?false:true
			// {
			// 	...this.state.open,
			// 	[index]: this.state.open[index]?false:true
			// }
		})
	}
	
	handleOnChangeImage = ( value, mainIndex, subIndex ) => {
		this.props.updateSubCategoryImage({ mainIndex, subIndex, value });
	}
	
	handleOnSaveImage = ({ mainCategory, subCategory }) => {
		
		_postSaveSubCategoryImage({ 
			subKebabCase: subCategory.titleUrl, 
			categoryId: mainCategory._id,
			image: subCategory.image
		})
			.then( res => {
				message.success(`Updated ${subCategory.title}'s image`);
			})
			.catch( e => {
				alert( e.toString() );
			})
		
	}

	handleOnSaveGoogleTaxonomy = async (mainIndex, subIndex) => {
		const mainCategory = this.props.category
		const taxonomySearchParam = this.state[`${mainIndex}.${subIndex}.searchParam`]
		const subCategory = this.props.category.children[subIndex];
		
		try {
			await _putUpdateSubCategoryGoogleTaxonomy({
				mainCategory,
				subCategory,
				googleTaxonomy: taxonomySearchParam
			})

			message.success(`Updated ${subCategory.title}'s Google Taxonomy`);
		} catch(err) {
			message.error(`An error occured!`);
		}
	}

	resetTaxonomy = ({ mainIndex, subIndex, subCategory }) => {

		this.setState({
			[`${mainIndex}.${subIndex}.searchParam`]: subCategory.googleTaxonomy,
			[`${mainIndex}.${subIndex}.taxonomy`]: [],
			[`${mainIndex}.${subIndex}.dirtyInput`]: false
		})

	}

	updateGoogleTaxonomy = ({ mainIndex, subIndex, googleTaxonomy }) => {

		this.setState({
			[`${mainIndex}.${subIndex}.searchParam`]: googleTaxonomy,
			[`${mainIndex}.${subIndex}.taxonomy`]: [],
			[`${mainIndex}.${subIndex}.dirtyInput`]: false

		});

		// set to actual object in redux?????
		this.props.updateGoogleTaxonomy({ mainIndex, subIndex, googleTaxonomy });

	}

	setSpecTableEditorVisibility = ( visiblity, subKebabCase = '' ) => {
		this.setState({
			editSpecTable: visiblity,
			editSubKebabCase: subKebabCase
		});
	}

}

export default connect(
	(state, props) => {

		return {
			category: state.categories.data[props.index]
		}

	},

	dispatchEvent => ({
		updateGoogleTaxonomy: ( obj ) => dispatchEvent( updateGoogleTaxonomy( obj ) ),
		updateSubCategoryImage: ({ mainIndex, subIndex, value }) => dispatchEvent( updateSubCategoryImage({mainIndex, subIndex, value}) )
	})
)(CategoryRow);


// WEBPACK FOOTER //
// ./src/components/category/category-row.js